import NiceModal from '@ebay/nice-modal-react';

import { ProfileCompletedPopupController } from './profile-completed-popup.controller';

export const profileCompletedPopupModalId = 'profile-completed-popup' as const;
const ProfileCompletedPopupModal = NiceModal.create(ProfileCompletedPopupController);
NiceModal.register(profileCompletedPopupModalId, ProfileCompletedPopupModal);
